import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import AuthLayout from '../../../layouts/AuthLayout/AuthLayout';
import { useLanguage } from '../../../context/LanguageProvider/LanguageProvider';

import { NioCard, NioBrand, NioField, NioButton } from '../../../components';
import AuthLogo from '../../../components/AuthLogo/AuthLogo';

export default function ResetPassword() {
  const { t } = useLanguage();

  return (
    <AuthLayout titleKey="auth.reset.docTitle" rootClass="layout-1">
      <NioCard className="nk-form-card card-gutter-md nk-auth-form-card mx-md-9 mx-xl-auto">
        <NioCard.Body>
          <div className="nk-form-card-head text-center pb-5">
            <div className="form-logo mb-4">
              <AuthLogo />
            </div>
            <h3 className="title mb-2">{t('auth.reset.title')}</h3>
            <p className="text">
              {t('auth.reset.sub')}{' '}
              <Link to="/auth/login" className="btn-link text-primary">
                {t('auth.reset.loginLink')}
              </Link>
              .
            </p>
          </div>
          <Form onSubmit={(e) => e.preventDefault()}>
            <Row className="gy-4">
              <Col xs={12}>
                <NioField htmlFor="password" label={t('auth.reset.password')}>
                  <NioField.Input
                    id="password"
                    type="password"
                    icon="eye-fill after text-primary"
                    placeholder={t('auth.reset.passwordPh')}
                  />
                </NioField>
              </Col>
              <Col xs={12}>
                <NioField htmlFor="cpassword" label={t('auth.reset.confirm')}>
                  <NioField.Input
                    id="cpassword"
                    type="password"
                    icon="eye-fill after text-primary"
                    placeholder={t('auth.reset.confirmPh')}
                  />
                </NioField>
              </Col>
              <Col xs={12}>
                <div className="form-group">
                  <NioButton href="/auth/login" label={t('auth.reset.submit')} className="btn-block btn-primary" />
                </div>
              </Col>
            </Row>
          </Form>
        </NioCard.Body>
      </NioCard>
    </AuthLayout>
  );
}
